import { RootState } from "@/store/store";
import { widgetByIdSelector } from "@/store/dashboards/selectors/widgets/common/widgetByIdSelector";

export const widgetInheritsDatesByIdSelector = (
  state: RootState,
  widgetId: string,
) => {
  const widget = widgetByIdSelector(state, widgetId);

  return !!(widget && "inherit_dates" in widget && widget.inherit_dates);
};
